import React from 'react';
import Button from '@splunk/react-ui/Button';
import { _ } from '@splunk/ui-utils/i18n';

interface DownloadButtonProps {
    modalStep: number;
    isDownloadingTabs: boolean;
    onClick: () => Promise<void>;
}

export const DownloadButton = ({
    modalStep,
    isDownloadingTabs,
    onClick,
}: DownloadButtonProps) => {
    if (modalStep === 0) {
        return null;
    }

    return (
        <Button
            appearance="primary"
            disabled={
                modalStep === 2 && !isDownloadingTabs ? undefined : 'dimmed'
            }
            label={_('Download')}
            onClick={onClick}
        />
    );
};
